export default __webpack_public_path__ + "static/media/explorandes1.a246e3a3.jpg";